<template>
  <div>
    <TableFilters :filters="['dateRange']" v-model="filter"></TableFilters>
    <v-row>
      <v-container fluid>
        <v-row>
          <!-- Shop or Warehouse radio button component -->
          <v-col cols="4" sm="4" lg="4" md="4" class="pt-1 d-flex">
            <v-radio-group v-model="row" row>
              <label class="textStyle"
                ><input
                  type="radio"
                  name="category_id"
                  @change="shopSelected()"
                  class="form-control"
                  value="1"
                />
                Shop
              </label>
              <label class="textStyle"
                ><input
                  type="radio"
                  name="category_id"
                  @change="warehouseSelected()"
                  class="form-control ml-3"
                  value="2"
                />
                Warehouse</label
              >
            </v-radio-group>
            <!-- {{this.filterDatas.start}} -->
          </v-col>
          <!-- Warehouse select component when selecting warehouse -->
          <v-col
            cols="4"
            sm="4"
            lg="4"
            md="4"
            class="pt-1 d-flex"
            v-if="isWarehouse"
          >
            <v-row>
              <v-combobox
                hide-details="auto"
                hide-no-data
                v-model="selectedWarehouse"
                @change="searchWarehouse = ''"
                @input="GetWarehouse(searchWarehouse)"
                :items="WarehouseDataList"
                clearable
                :search-input.sync="searchWarehouse"
                outlined
                item-text="name"
                item-value="id"
                label="Select Warehouse"
                multiple
                small-chips
                class="mr-9 comboStyle"
              >
              </v-combobox>
            </v-row>
            <v-row>
              <v-btn
                depressed
                small
                height="32"
                class="btn_transparent w-100"
                @click="GetWarehouseReportList()"
              >
                <v-icon
                  large
                  color="primary darken-2"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-1"
                >
                  mdi-archive-plus
                </v-icon>
              </v-btn>
            </v-row>
          </v-col>
          <!-- Shop select component when selecting Shop -->
          <v-col
            cols="3"
            sm="3"
            lg="3"
            md="3"
            class="px-0 pt-1 d-flex"
            v-if="isShop"
          >
            <v-row>
              <v-combobox
                hide-details="auto"
                hide-no-data
                v-model="selectedShop"
                @change="searchShops = ''"
                :items="ShopsData"
                clearable
                :search-input.sync="searchShops"
                outlined
                item-text="name"
                item-value="id"
                label="Select Shop"
                multiple
                small-chips
                class="mr-9 comboStyle"
              >
              </v-combobox>
            </v-row>
            <v-row>
              <v-btn
                depressed
                small
                height="32"
                class="btn_transparent w-100"
                @click="GetShopReportList()"
              >
                <v-icon
                  large
                  color="primary darken-2"
                  v-bind="attrs"
                  v-on="on"
                  class="ma-1"
                >
                  mdi-archive-plus
                </v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <template v-if="isWarehouse">
          <v-row>
            <v-flex
              v-for="item in warehouseindex"
              :key="item.warehouse.id"
              xs12
              md6
              lg3
            >
              <v-card
                class="mx-auto lg-6 md-6 cols-6 sd-6"
                max-width="500"
                elevation="2"
                outlined
                shaped
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="6">
                        <!-- warehouse id -->
                        <div class="text-overline mb-4">
                          WAREHOUSE ID: {{ item.warehouse.id }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <div class="mb-4">from: {{ filterDatas.start }}</div>
                        </v-row>
                        <v-row>
                          <div class="mb-4">to: {{ filterDatas.end }}</div>
                        </v-row>
                      </v-col>
                    </v-row>
                    <!-- warehouse name -->
                    <v-list-item-title class="text-h6 mb-1 heading">
                      {{ item.warehouse.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle></v-list-item-subtitle>
                    <hr />
                    <v-list-item-title class="mt-2 mb-1">
                      <v-row>
                        <v-col>
                          <v-row class="ml-1 subHeading mb-2">
                            Purchases
                          </v-row>
                          <v-row class="ml-1 listData"
                            >Count: {{ item.purchse.count }}</v-row
                          >
                        </v-col>

                        <v-col>
                          <v-row class="listData justify-end mr-2 mb-1"
                            >Total:
                            {{ item.purchse.total | formatCurrency }}</v-row
                          >
                          <v-row class="listData justify-end mr-2 mb-1"
                            >Paid:
                            {{ item.purchse.Paid | formatCurrency }}</v-row
                          >
                          <v-row class="listData justify-end mr-2"
                            >Total:
                            {{ item.purchse.total | formatCurrency }}</v-row
                          >
                        </v-col>
                      </v-row>
                      <v-row class="mt-2">
                        <v-col>
                          <v-row class="ml-1 subHeading"> Expense </v-row>
                        </v-col>
                        <v-col>
                          <v-row class="listData justify-end mr-2 mb-1"
                            >Paid:
                            {{ item.expense.paid | formatCurrency }}</v-row
                          >
                          <v-row class="listData justify-end mr-2"
                            >Unpaid:
                            {{ item.expense.notPaid | formatCurrency }}</v-row
                          >
                        </v-col>
                      </v-row>
                      <v-row class="mt-2">
                        <v-col>
                          <v-row class="ml-1 subHeading"> Income </v-row>
                        </v-col>
                        <v-col>
                          <v-row class="listData justify-end mr-2"
                            >Total: {{ item.income | formatCurrency }}</v-row
                          >
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                    <v-list-item> </v-list-item>
                  </v-list-item-content>
                </v-list-item>

                <!-- <v-card-actions>
                  <v-btn outlined rounded text class="subHeading">
                    Remove
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </v-flex>
          </v-row>
        </template>
        <template>
          <v-row>
            <v-flex v-for="item in index" :key="item.shop.id" xs12 md6 lg3>
              <v-card
                class="mx-auto lg-6 md-6 cols-6 sd-6 ml-2"
                max-width="500"
                v-if="index.length > 0"
                elevation="2"
                outlined
                shaped
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-col cols="6">
                      <!-- shop id -->
                      <div class="text-overline mb-4">
                        SHOP ID: {{ item.shop.id }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="justify-end">
                      <v-row>
                        <div class="mb-4">from: {{ filterDatas.start }}</div>
                      </v-row>
                      <v-row>
                        <div class="mb-4">to: {{ filterDatas.end }}</div>
                      </v-row>
                    </v-col>
                    <!-- shop name -->
                    <v-list-item-title class="text-h6 mb-1 heading">
                      {{ item.shop.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle></v-list-item-subtitle>
                    <hr />
                    <v-list-item-title class="mt-2 mb-1">
                      <v-row>
                        <v-col>
                          <v-row class="ml-1 subHeading"> Sales </v-row>
                          <v-row class="ml-1 mt-2 listData"
                            >Count: {{ item.sale.count }}</v-row
                          >
                        </v-col>
                        <v-col>
                          <v-row class="listData justify-end mr-2 mt-1"
                            >Total:
                            {{ item.sale.total | formatCurrency }}</v-row
                          >
                          <v-row class="listData justify-end mr-2 mt-2"
                            >Paid: {{ item.sale.Paid | formatCurrency }}</v-row
                          >
                          <v-row class="listData justify-end mr-2 mt-2"
                            >Discount:
                            {{ item.sale.Discount | formatCurrency }}</v-row
                          >
                        </v-col>
                      </v-row>
                      <v-row class="mt-2">
                        <v-col>
                          <v-row class="ml-1 subHeading"> Expense </v-row>
                        </v-col>
                        <v-col>
                          <v-row class="listData justify-end mr-2"
                            >Total:
                            {{ item.expense.paid | formatCurrency }}</v-row
                          >
                          <v-row class="listData justify-end mr-2 mt-1"
                            >Paid:
                            {{ item.expense.notpaid | formatCurrency }}</v-row
                          >
                        </v-col>
                      </v-row>
                      <v-row class="mt-2">
                        <v-col>
                          <v-row class="ml-1 subHeading"> Income </v-row>
                        </v-col>
                        <v-col>
                          <v-row class="listData justify-end mr-2 mt-1"
                            >Total: {{ item.income | formatCurrency }}</v-row
                          >
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                    <v-list-item> </v-list-item>
                  </v-list-item-content>
                </v-list-item>

                <!-- <v-card-actions>
                  <v-btn outlined rounded text class="subHeading">
                    Remove
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </v-flex>
          </v-row>
        </template>
      </v-container>
    </v-row>
  </div>
</template>
<script>
import { Product } from '../../../models/Product';
import _ from 'lodash';
import { SupplierListViewModel } from '@/models/View Models/Supplier';
import confirmation from '../../shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../../shared/components/pagination.vue';
import { ProductViewModel } from '../../../models/View Models/ProductViewModel';
import axios from '../../../plugins/axios';
import HorizontalScroll from 'vue-horizontal-scroll';
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css';
import { mapState } from 'vuex';

export default {
  data: () => ({
    Product: new Product(),
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    shopshortname: '',
    inheritAttrs: false,
    paginationOptions: {},
    searchShops: null,
    searchWarehouse: null,
    selectedShop: [],
    selectedWarehouse: [],
    ShopsData: [],
    WarehouseDataList: [],
    ShopDataList: [],
    WarehouseDataReport: [],
    shopIds: [],
    warehouseIds: [],
    index: [],
    column: null,
    row: null,
    isShop: false,
    isWarehouse: false,

    columns: [
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    filter: {
      search: '',
      start: '',
      end: '',
    },
    date_range: [],
    ProdctShopsData: [],
    WarehouseData: [],
    productDetails: [],
    ShopDataListIDs: [],
  }),
  props: {
    module: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: { paginationComponent, TableFilters, HorizontalScroll },

  created() {
    this.GetWarehouse();
    this.GetShops();
    this.GetShopReport();
    this.GetWarehouseReport();
  },
  computed: {
    ...mapState(['filterDatas']),
  },

  watch: {
    searchShops(value) {
      if (value == null) {
        return;
      }
      // if (!value) {
      //   this.GetShops("");
      // }
      this.GetShops(value);
    },
    searchWarehouse(value) {
      if (value == null) {
        return;
      }
      this.GetWarehouse(value);
    },
    filter: function () {
      this.GetShopReport();
      this.GetWarehouseReport();
    },
  },

  methods: {
    shopSelected() {
      this.isShop = true;
      this.isWarehouse = false;
    },
    warehouseSelected() {
      this.isWarehouse = true;
      this.isShop = false;
    },
    shopDetails(shop) {
      this.shopshortname = shop.sortform;
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.shopdetails.refreshData();
    },
    async GetShopReportList() {
      this.shopIds = [];
      this.selectedShop.map((p) => {
        this.shopIds.push(p.id);
      });

      this.GetSelectedShopDataIndex();
    },
    async GetWarehouseReportList() {
      this.warehouseIds = [];
      this.index = [];
      this.selectedWarehouse.forEach((element) => {
        this.warehouseIds.push(element.id);
      });
      this.GetSelectedWarehouseDataIndex();
    },

    GetShopReport() {
      var filter = this.filter;
      this.ShopDataList = [];
      this.WarehouseDataReport = [];
      this.$store
        .dispatch('report/GetShopOverviewReport', filter)
        .then((res) => {
          this.ShopDataList = res.data.data;
        });
    },
    GetWarehouseReport() {
      var filter = this.filter;
      this.WarehouseDataReport = [];
      this.ShopDataList = [];
      this.$store
        .dispatch('report/GetWarehouseOverviewReport', filter)
        .then((res) => {
          this.WarehouseDataReport = res.data.data;
        });
    },
    GetSelectedShopDataIndex() {
      this.index = [];
      this.ShopDataList.forEach((element) => {
        this.shopIds.forEach((shopID) => {
          if (shopID == element.shop.id) {
            this.index.push(element);
          }
        });
      });
    },
    GetSelectedWarehouseDataIndex() {
      this.warehouseindex = [];
      this.index = [];
      this.WarehouseDataReport.forEach((element) => {
        this.warehouseIds.forEach((ID) => {
          if (ID == element.warehouse.id) {
            this.warehouseindex.push(element);
          }
        });
      });
    },

    openConfirmation(item) {
      confirmation.dialog = true;

      this.$confirm('Do you want to Remove ?').then((res) => {
        if (res) {
          this.removeShop(item);
        }
      });
    },
    // Shop Remove Function
    async removeShop(item) {
      const credentials = new Object();
      credentials.shops = [item.id];
      credentials.productId = this.$route.params.id;

      this.removeShopFromProduct(credentials);
    },

    removeShopFromProduct(credentials) {
      this.$store
        .dispatch(`product/RemoveShopFromProduct`, credentials)
        .then((res) => {
          this.refreshData();
          if (this.ProdctShopsData) {
            let index = this.ProdctShopsData.findIndex(
              (p) => p.id == credentials.shops[0],
            );
            if (index != -1) {
              this.ProdctShopsData.splice(index, 1);
            }
          }
          this.$toast.success('Shop removed successfully');

          this.selectedShop = [];
          this.GetShops();

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to remove shop');
          //   this.payment = new Payment();
        });
    },
    // Warehouse remove Function
    async removeWarehouse(item) {
      const credentials = new Object();
      credentials.warehouse = [item.id];
      credentials.productId = this.$route.params.id;

      this.removeShopFromProduct(credentials);
    },
    receiveShopsResponse(data) {
      this.ProdctShopsData = data;
      this.GetShops();
      this.GetWarehouse();
    },

    GetShops(query = '') {
      this.searchShops = null;
      let except = [];
      if (this.selectedShop && this.selectedShop.length > 0) {
        this.selectedShop.forEach((shop) => {
          except.push(shop.id);
        });
      }
      this.$store
        .dispatch('shop/GetShop', {
          query: query,
          except: except,
          status: 'active',
        })
        .then((res) => {
          this.ShopsData = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    GetWarehouse(query = '') {
      this.searchWarehouse = null;
      let except = [];

      if (this.selectedWarehouse && this.selectedWarehouse.length > 0) {
        this.selectedWarehouse.forEach((warehouse) => {
          except.push(warehouse.id);
        });
      }
      axios
        .get('ware-houses?')
        .then((res) => {
          this.WarehouseDataList = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },
};
</script>

<style scoped>
.productdetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: left;

  color: #000000;
}
.heading {
  color: deepskyblue;
}
.subHeading {
  font-weight: bold;
  font-size: 18px;
}
.listData {
  font-weight: bold;
  font-size: 15px;
}

.textStyle {
  font-weight: 600 !important;
}

.comboStyle {
  width: 400px !important;
}
</style>
